import React from 'react';
import { connect } from 'react-redux';
import Popup from 'reactjs-popup';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import styles from './AccountActivation.module.less';
import AccountActivationModal from './AcountActivationModal';
import RejectModal from './RejectInvitationModal';
import { ProfileSelectors } from '../../../Redux/modules/profile/selectors';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';

const getModalStyle = () => {
  return {
    width: '528px',
    boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
    border: 'none',
    borderRadius: '8px',
    padding: '40px 80px',
    backgroundColor: '#ffffff',
  };
};

const AccountActivation = (props) => {
  const { orgAdmin } = props;
  return (
    <div id="invitation-container">
      <div className={styles.header} id="account-invitation-title">
        {gettext('Account Invitation')}
      </div>
      <div className={styles.text} id="invitation-text">
        {gettext('You have a pending invitation from ')}
        <strong>{orgAdmin}</strong>
      </div>

      <div className={styles.buttons}>
        <Popup
          trigger={
            <div className={styles.buttonAccept} id="accept-invitation-button">
              <AnalyticsHandler eventName={AnalyticsEventNames.ACCEPT_INVITE}>
                <Button
                  buttonClass="primary-green"
                  id="accept-button"
                  text={gettext('Accept Invitation')}
                  width="30%"
                  isLoading={props.isLoading}
                  closeOnDocumentClick={false}
                />
              </AnalyticsHandler>
            </div>
          }
          modal
          closeOnDocumentClick
          contentStyle={getModalStyle()}
        >
          {(close) => <AccountActivationModal close={close} />}
        </Popup>

        <Popup
          trigger={
            <div className={styles.buttonReject} id="reject-invitation-button">
              <Button
                buttonClass="primary-red"
                id="reject-button"
                text={gettext('Reject Invitation')}
                isLoading={props.isLoading}
                closeOnDocumentClick={false}
              />
            </div>
          }
          modal
          closeOnDocumentClick
          contentStyle={getModalStyle()}
        >
          {(close) => <RejectModal close={close} />}
        </Popup>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    orgAdmin: ProfileSelectors.profileInvitedBySelector(state),
  };
};

AccountActivation.propTypes = {
  isLoading: PropTypes.bool,
  orgAdmin: PropTypes.string,
};

export default connect(mapStateToProps)(AccountActivation);
